const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

export const EnvironmentBanner = () => {
  if (ENVIRONMENT !== 'dev') {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-red-600 text-white text-center py-1 text-sm font-medium">
      DEV ENVIRONMENT
    </div>
  );
};